import { RightOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import React, { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import IconLockOn from '@/assets/images/icons/icon-lock-on.react.svg?react';
import IconQrcode from '@/assets/images/icons/icon-qrcode.react.svg?react';
import IconQuestion from '@/assets/images/icons/icon-question.react.svg?react';
import QrcodeImg from '@/assets/images/index/1x/qrcode-img1x.png';
import { Aisee } from '@/presentation/layouts-pro/tools/aisee';
import styles from './index.module.scss';

export interface CustomerServicePopoverProps {
  children: React.ReactNode;
}

export const CustomerServicePopover: FC<CustomerServicePopoverProps> = ({ children }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const aiseeRef = useRef<{ showAisee: () => void }>(null);

  const showAisee = () => {
    aiseeRef?.current?.showAisee();
  };

  const gotoBusinessConsult = () => {
    history.push('/consult');
  };

  const content = (
    <div className={styles.popoverContent}>
      <ul>
        <li className={styles.qrcodeContent}>
          <div className={styles.icon}><IconQrcode /></div>
          <span>{t('联系我们')}</span>
          <div className={styles.qrcodeImg}>
            <img src={QrcodeImg} alt="" />
          </div>
        </li>
        <li onClick={gotoBusinessConsult}>
          <div className={styles.icon}><IconLockOn /></div>
          <span>{t('商务咨询')}</span>
          <div><RightOutlined /></div>
        </li>
        <li onClick={showAisee}>
          <div className={styles.icon}><IconQuestion /></div>
          <span>{t('问题反馈')}</span>
          <div><RightOutlined /></div>
        </li>
      </ul>
    </div>
  );

  return (
    <>
      <Popover
        placement="bottom"
        content={content}
        overlayClassName={styles.popover}
      >
        {children}
      </Popover>
      <Aisee ref={aiseeRef} />
    </>
  );
};
